export default {
  // 查看协议
  look: "agreement_look",
  // 编辑协议
  edit: "agreement_edit"
}